module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/标签-置顶贴.934f4.png";